module.exports = __webpack_public_path__ + "static/theme-editor-newsletter-749e0740f98f0c217eaac759f3504985.png";